<div class="content-div">
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
    <app-basic-button type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>

  <div class="top-bar">
    <span class="page-header">
      {{ 'users:users_tooltip_filterHeader' | i18next  }}
    </span>
    <div class="right">
      <app-filter-input [(model)]="filter" (modelChange)="applyFilterFromProperty()"
        [placeholder]="'realtime:shared_lang_tableFilterLabel' | i18next"  [width]="'350px'"></app-filter-input>
    </div>
  </div>

  <div class="content">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <div class="inner-content">

      <div class="actions top-bar">
        <app-basic-button type="secondary" size="medium" (click)="addFilter()">
          <i class="far fa-plus fs-16"></i>
          {{ 'users:usersfilter_addFilter' | i18next  }}
        </app-basic-button>
        <div class="right">
          <app-basic-button type="primary" size="medium" (click)="saveChanges()" [disabled]="!hasChanges || isLoading || hasInvalidInputs()">
            {{ 'users:SaveChanges' | i18next  }}
          </app-basic-button>
        </div>
      </div>

      <table mat-table [dataSource]="dataSource" matSort class="full-width-table">

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="left nowrap">
            {{ 'users:usersfilter_name' | i18next  }}
          </th>
          <td mat-cell *matCellDef="let row" class="left nowrap">
            <ng-container *ngIf="!row.isEditing; else editMode">
              <a (click)="navigateToFilter(row)">{{row.description | htmlDecode}}</a>
            </ng-container>
            <ng-template #editMode>
              <app-basic-textbox [(model)]="row.editName" size="small"
                [class.input-validation-error]="row.isTouched && row.editName && isInvalidName(row.editName)"
                (modelChange)="onEdit(row)" [hasError]="row.isTouched && isInvalidName(row.editName)"  [errorText]="'users:usersfilter_err_invalidName' | i18next">
              </app-basic-textbox>
            </ng-template>
          </td>
        </ng-container>

        <!-- Edit Column -->
        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef class="left">
            {{ 'users:usersfilter_edit' | i18next  }}
          </th>
          <td mat-cell *matCellDef="let row" class="left">
            <app-basic-button type="secondary" isIcon="true" size="small" (click)="editFilter(row)" [focusVisible]="row.isEditing">
              <i class="far fa-edit"></i>
            </app-basic-button>
          </td>
        </ng-container>

        <!-- Delete Column -->
        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef class="left">
            {{ 'users:usersfilter_delete' | i18next  }}
          </th>
          <td mat-cell *matCellDef="let row" class="left">
            <app-basic-button type="secondary" isIcon="true" size="small" type="decline" (click)="deleteFilter(row)"
              [disabled]="row.inUse">
              <i class="fal fa-times"></i>
            </app-basic-button>
          </td>
        </ng-container>

        <!-- header, rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- No data row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <ng-container *ngTemplateOutlet="noData"></ng-container>
          </td>
        </tr>
      </table>
    </div>
    <!-- No-data template -->
    <ng-template #noData>
      <div class="no-items">
        {{ 'realtime:noResults' | i18next }}
      </div>
    </ng-template>

    <div *ngIf="pendingDeletes.length > 0" class="pending-deletes">
      <p>{{ 'users:usersfilter_err_pendingDeletes' | i18next  }}</p>
      <ul>
        <li *ngFor="let del of pendingDeletes">{{ del }}</li>
      </ul>
    </div>
  </div>
</div>
